import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
} from "@material-ui/core";
import { TextField, Typography } from "@material-ui/core";

import { changeAccount } from "../redux";
import { editAccount, updateCourseStudentIdentifier } from "../firebaseApi";

const styles = (theme) => ({});

function StudentSettings(props) {
  let { account } = props;

  const [loading, setLoading] = React.useState(false);
  // const [notFilled, setNotFilled] = React.useState(false);
  const [values, setValues] = React.useState({
    firstName: account.accountFirstName,
    lastName: account.accountLastName,
    email: account.accountEmail,
    // identifier: account.accountIdentifier || "",
  });

  // React.useEffect(() => {
  //   setValues({
  //     firstName: account.accountFirstName,
  //     lastName: account.accountLastName,
  //     email: account.accountEmail,
  //     identifier: account.accountIdentifier || "",
  //   });
  // }, [account.accountEmail, account.accountIdentifier]);

  React.useEffect(() => {
    setValues({
      firstName: account.accountFirstName,
      lastName: account.accountLastName,
      email: account.accountEmail,
    });
  }, [account.accountEmail ]);

  return (
    <Dialog open={props.open}>
      <DialogTitle>Settings</DialogTitle>
      <DialogContent>
        <TextField
          style={{ paddingBottom: "20px" }}
          label="First Name"
          onChange={(event) =>
            setValues({ ...values, firstName: event.target.value })
          }
          value={values.firstName}
        />
        <TextField
          label="Last Name"
          onChange={(event) =>
            setValues({ ...values, lastName: event.target.value })
          }
          value={values.lastName}
        />
        <TextField
          style={{ paddingBottom: "20px" }}
          label="Email"
          fullWidth
          disabled
          value={values.email}
        />
        {/* <TextField
          label="Student Identifier"
          fullWidth
          onChange={(event) =>
            setValues({ ...values, identifier: event.target.value })
          }
          value={values.identifier}
        />
        {notFilled ? (
          <Typography style={{ color: "red", paddingTop: "5px" }}>
            Please fill student identifier
          </Typography>
        ) : null} */}

        <DialogActions>
          <Button
            onClick={() => {
              // if (props.forcePID && !values.identifier) {
              //   setNotFilled(true);
              //   return;
              // }
              props.openCtl(false);
              // setNotFilled(false);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              // if (props.forcePID && !values.identifier) {
              //   setNotFilled(true);
              //   return;
              // }

              // setNotFilled(false);
              setLoading(true);
              // let { firstName, lastName, identifier } = values;
              let { firstName, lastName } = values;

              // Update all courses student identifiers
              // if (account.accountIdentifier != identifier) {
              //   let data = { accountID: account.accountEmail, identifier };
              //   updateCourseStudentIdentifier(data);
              // }
              props
                // .editStudentInfo(firstName, lastName, identifier)
                .editStudentInfo(firstName, lastName )
                .then(() => {
                  setLoading(false);
                  props.openCtl(false);
                });
            }}
          >
            Save
          </Button>
        </DialogActions>
      </DialogContent>

      {loading && <LinearProgress />}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(StudentSettings))
  )
);
